import React from 'react';

import styled from 'styled-components';

import { styleIf } from '@sine/sine-ui-components';

const APP_TYPE = {
  APP_STORE: 'app-store',
  GOOGLE_PLAY: 'google-play',
};

const apps = {
  sinePass: {
    url: 'https://play.google.com/store/apps/details?id=co.sine.sinecloud.pass&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
    type: APP_TYPE.GOOGLE_PLAY,
    imageUrl: 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png',
  },
  sinePro: {
    url: 'https://apps.apple.com/au/app/sine-pro/id1086883094?mt=8',
    type: APP_TYPE.APP_STORE,
    imageUrl: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us',
  },
  sinePoint: {
    url: 'https://apps.apple.com/au/app/sine-point-pro/id1086882588?mt=8',
    type: APP_TYPE.APP_STORE,
    imageUrl: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us',
  },
};

const StoreBadgeItem = styled.a<{ imageUrl: string }>`
  overflow: hidden;
  background-repeat: no-repeat;
  width: 135px;
  height: 40px;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};

  ${({ type }) => styleIf(type === APP_TYPE.GOOGLE_PLAY)`
    background-position: center;
    background-size: 154.5px;
    `}
`;

export default function StoreBadge({ app }: { app: keyof typeof apps }) {
  return (
    <StoreBadgeItem
      href={apps[app].url}
      imageUrl={apps[app].imageUrl}
      type={apps[app].type}
      target='_blank'
      rel='noopener noreferrer'
      data-st-ext={`button-${apps[app].type}`}
    />
  );
}
